export default __webpack_public_path__ + "static/media/image.ef34536c.svg";